<template>
  <v-container>
    <remitUnitList/>
  </v-container>
</template>

<script>

import remitUnitList from '../../components/shared/remitUnits/remitUnitList.vue';

export default {
  name: 'remitUnit',
  components: {
    remitUnitList,
  },
};

</script>
